// CSV export helpers.
//
// The admin/account analytics exports include participant-controlled text
// (names, video titles, categories). Two hazards come from dropping those
// values straight into a CSV:
//   1. Correctness: a value containing a comma, quote, or newline shifts or
//      breaks columns.
//   2. CSV/formula injection: a cell beginning with = + - @ (or a tab/CR that
//      a spreadsheet trims down to one of those) is executed as a formula when
//      the file is opened in Excel/Sheets.
// csvCell() neutralizes both: it prefixes a single quote to formula-leading
// values, then always wraps the cell in quotes and doubles any internal quote.

const FORMULA_LEADERS = ["=", "+", "-", "@", "\t", "\r"];

export const csvCell = (value) => {
  const str = value === null || value === undefined ? "" : String(value);
  const neutralized = FORMULA_LEADERS.includes(str.charAt(0)) ? `'${str}` : str;
  return `"${neutralized.replace(/"/g, '""')}"`;
};

// Turn an array of rows (each an array of cell values) into CSV text with CRLF
// line endings, escaping every cell.
export const toCsv = (rows) =>
  rows.map((row) => row.map(csvCell).join(",")).join("\r\n");

// Trigger a client-side download of `rows` as a CSV file named `filename`.
// Uses a Blob URL rather than a `data:` URI so the content is not URL-encoded
// (encodeURI mangles the escaping and silently corrupts large exports).
export const downloadCsv = (rows, filename) => {
  const blob = new Blob([toCsv(rows)], {type: "text/csv;charset=utf-8;"});
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
